// Per-project Meta (Facebook) Page account: status, connect (OAuth redirect),
// disconnect, and on-demand lead sync.

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { crmApi } from "../api/client";

const key = (projectId) => ["crm", "project-meta-account", projectId];

export function useProjectMetaAccount(projectId) {
  return useQuery({
    queryKey: key(projectId),
    enabled: !!projectId,
    queryFn: async () => {
      const { data } = await crmApi.get(`/projects/${projectId}/meta-account`);
      return data;
    },
    staleTime: 30_000,
  });
}

export function useStartMetaConnect() {
  return useMutation({
    mutationFn: async (projectId) => {
      const { data } = await crmApi.get(`/auth/meta/start`, { params: { projectId } });
      return data;
    },
  });
}

export function useDisconnectMetaAccount(projectId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await crmApi.delete(`/projects/${projectId}/meta-account`)).data,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: key(projectId) });
    },
  });
}

export function useSyncMetaLeads(projectId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => (await crmApi.post(`/projects/${projectId}/meta-account/sync`, null, { timeout: 120000 })).data,
    onSuccess: () => {
      // Refresh leads list after sync so new leads appear immediately.
      qc.invalidateQueries({ queryKey: ["crm", "leads"] });
    },
  });
}
